import reactUpdate from 'immutability-helper';

import {EventConstants} from 'constants/EventConstants';
import {Batch} from 'constants/SampleConstants';
import AppDispatcher from 'lib/Dispatcher';
import {FluxAction} from 'lib/Dispatcher';
import Store from 'lib/Store';

interface ApplicableBatchesFetchCompletedAction {
  actionType: typeof EventConstants.APPLICABLE_BATCHES_FETCH_COMPLETED;
  fileId: string;
  batchLinkFieldId: string;
  batches: Array<Batch>;
}

interface FileTagsUpdatedAction {
  actionType: typeof EventConstants.FILE_TAGS_UPDATED;
  tagData: Array<{id: string; tags: Array<unknown>}>;
}

class ApplicableBatchesStore extends Store {
  // Stores the batches that can be used as batch link fields when creating a batch for a file.

  public applicableBatchesByFile: Record<string, Record<string, Array<Batch>> | null> = {};

  resetState(): void {
    this.applicableBatchesByFile = {};
  }

  getApplicableBatches(fileId: string, batchLinkFieldId: string): Array<Batch> | null {
    return this.applicableBatchesByFile[fileId]?.[batchLinkFieldId] ?? null;
  }

  payloadHandler(action: FluxAction): boolean {
    switch (action.actionType) {
      case EventConstants.APPLICABLE_BATCHES_FETCH_COMPLETED: {
        const {fileId, batchLinkFieldId, batches} = action as ApplicableBatchesFetchCompletedAction;
        if (!this.applicableBatchesByFile[fileId]) {
          this.applicableBatchesByFile[fileId] = {};
        }

        this.applicableBatchesByFile = reactUpdate(this.applicableBatchesByFile, {
          [fileId]: {[batchLinkFieldId]: {$set: batches}},
        });

        this.emitChange();
        break;
      }
      case EventConstants.FILE_TAGS_UPDATED: {
        const {tagData} = action as FileTagsUpdatedAction;
        const fileIds = tagData.map((item) => item.id);
        fileIds.forEach((fileId) => {
          this.applicableBatchesByFile[fileId] = null;
        });
        this.emitChange();
        break;
      }
      default:
        break;
    }
    return true;
  }
}

const applicableBatchesStore = new ApplicableBatchesStore(AppDispatcher);
export default applicableBatchesStore;
